/** `#rrggbb` → `rgba(r,g,b,a)`. */
function rgba(hex: string, a: number): string {
  const n = Number.parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
}

/** A plain filled circle marker element (no outer rings/border). */
export function buildDotMarkerEl(args: { colour: string; radius: number }): HTMLElement {
  const size = args.radius * 2;
  const el = document.createElement('div');
  // 0.85 matches the surveillance sensor layer's live `circle-opacity`.
  el.style.cssText = `width:${size}px;height:${size}px;border-radius:50%;background:${rgba(args.colour, 0.85)};cursor:pointer`;
  return el;
}
